import { registerI18nResources } from '@mc/i18n'
import enUS from './locales/en-US.json'

export const MC_PRO_TIER_I18N_NAMESPACE =
  '@mc/checkout/experiments/prcng-1194_v1_mc_pro_tier'

export const i18nInstance = registerI18nResources({
  namespace: MC_PRO_TIER_I18N_NAMESPACE,
  resources: { 'en-US': enUS },
})
